export const teamFragment = `
team {
    name
    imagePath
    description
    teamId
    honoree
    subTeams {
        teamId
        name
        fullUrl
        honoree
        subTeamTotal
        outstandingMatchingGifts
        outstandingSponsorships
        fundraisingGoal
        officeName
        regDate
        eventName
        eventDate
    }
    teamMembers {
      country
      lastName
      address3
      teamMemberId
      middleInitial
      firstName
      phoneNumber
      areaCode
      address1
      postalCode
      state
      address2
      suffix
      imagePath
      imageId
      county
      countryCode
      city
      email
      fullUrl
      honoree
      onlineFunds
      offlineFunds
      totalFunds (orderBy: DESC)
      facebookFunds
      outstandingMatchingGifts
      outstandingSponsorships
      registrationStatusTypeId
      registrationStatusTypeName
      registrationStatusTypeDescription
      teamCard
      sportCourse
      fundraisingGoal
      officeName
      regDate
      eventName
      eventDate
      recommitted
      fundraisingCommitment
      prefixType {
        name
        cmgmtPrefixTypeId
        description
      }
      teamRoleType {
        description
        teamRoleTypeId
        activeFlag
        name
      }
    }
    fundraiser {
      fundraiserId
      fundraiserPageId
      fullUrl
      kickoffDate
      kickoffDateStr
      closeDonationsDate
      fundraisingGoal
      fundraisingMinimum
      canAcceptDonations
      activeFacebookFundraiserProfiles {
        facebookFundraiserId
      }
      facebookDonationsAmount
      fundraiserPosition
      fundraiserCount
      displayOnLeaderBoardFlag
      donationsReceived
      outstandingMatchingGifts
      outstandingSponsorships
      fundraiserType {
        name
      }
      fundraiserPageTemplateType {
        name
      }
      fundraiserPosts {
        fundraiserPostId
        publishedFl
        urlKey
        rawHtmlContent
        htmlContent
        publishedDate
        title
        fundraiserPostComments {
          comment
        }
      }
      fundraiserNewsFeeds {
        htmlContent
        fundraiserNewsFeedId
      }
    }
}
`;
